/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as ConnectorErrorRouteImport } from './routes/connector-error'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OrgMismatchRouteImport } from './routes/org-mismatch'
import { Route as PaymentInactiveRouteImport } from './routes/payment-inactive'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthOrgSlugRouteRouteImport } from './routes/_auth/$orgSlug/route'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/admin/route'
import { Route as UserPasswordResetRouteImport } from './routes/user/password-reset'
import { Route as UserResendVerificationRouteImport } from './routes/user/resend-verification'
import { Route as UserSetPasswordRouteImport } from './routes/user/set-password'
import { Route as UserVerifyRouteImport } from './routes/user/verify'
import { Route as UserVerifyEmailRouteImport } from './routes/user/verify-email'
import { Route as AuthOrgSlugIndexRouteImport } from './routes/_auth/$orgSlug/index'
import { Route as AuthOrgSlugProjectIdRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/route'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth/admin/index'
import { Route as AuthAdminActivityRouteImport } from './routes/_auth/admin/activity'
import { Route as AuthOrgSlugProjectIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/index'
import { Route as AuthOrgSlugProjectIdDocumentAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/document-agent/route'
import { Route as AuthOrgSlugProjectIdMarketingAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/route'
import { Route as AuthOrgSlugProjectIdPresentationAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/presentation-agent/route'
import { Route as AuthOrgSlugProjectIdProposalAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/proposal-agent/route'
import { Route as AuthOrgSlugProjectIdSearchAgentRouteRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/route'
import { Route as AuthOrgSlugAccountIndexRouteImport } from './routes/_auth/$orgSlug/account/index'
import { Route as AuthOrgSlugProfileIndexRouteImport } from './routes/_auth/$orgSlug/profile/index'
import { Route as AuthOrgSlugUsersIndexRouteImport } from './routes/_auth/$orgSlug/users/index'
import { Route as AuthOrgSlugProjectIdChatIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/chat/index'
import { Route as AuthOrgSlugProjectIdContentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/index'
import { Route as AuthOrgSlugProjectIdDocumentAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/document-agent/index'
import { Route as AuthOrgSlugProjectIdMarketingAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/index'
import { Route as AuthOrgSlugProjectIdPresentationAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/presentation-agent/index'
import { Route as AuthOrgSlugProjectIdProposalAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/proposal-agent/index'
import { Route as AuthOrgSlugProjectIdSearchAgentIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/index'
import { Route as AuthOrgSlugProjectIdWorkspaceIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/workspace/index'
import { Route as AuthOrgSlugContentConnectorIndexRouteImport } from './routes/_auth/$orgSlug/content/connector/index'
import { Route as AuthOrgSlugContentFileIndexRouteImport } from './routes/_auth/$orgSlug/content/file/index'
import { Route as AuthOrgSlugContentTextIndexRouteImport } from './routes/_auth/$orgSlug/content/text/index'
import { Route as AuthOrgSlugProjectIdChatConversationIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/chat/$conversationId/index'
import { Route as AuthOrgSlugProjectIdContentConnectorIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/connector/index'
import { Route as AuthOrgSlugProjectIdContentFileIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/file/index'
import { Route as AuthOrgSlugProjectIdContentTextIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/content/text/index'
import { Route as AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/marketing-agent/$threadId/index'
import { Route as AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/index'
import { Route as AuthOrgSlugProjectIdProposalAgentProposalIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/proposal-agent/$proposalId/index'
import { Route as AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport } from './routes/_auth/$orgSlug/$projectId/search-agent/$threadId/index'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectorErrorRoute = ConnectorErrorRouteImport.update({
  id: '/connector-error',
  path: '/connector-error',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgMismatchRoute = OrgMismatchRouteImport.update({
  id: '/org-mismatch',
  path: '/org-mismatch',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentInactiveRoute = PaymentInactiveRouteImport.update({
  id: '/payment-inactive',
  path: '/payment-inactive',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOrgSlugRouteRoute = AuthOrgSlugRouteRouteImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const UserPasswordResetRoute = UserPasswordResetRouteImport.update({
  id: '/user/password-reset',
  path: '/user/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const UserResendVerificationRoute = UserResendVerificationRouteImport.update({
  id: '/user/resend-verification',
  path: '/user/resend-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSetPasswordRoute = UserSetPasswordRouteImport.update({
  id: '/user/set-password',
  path: '/user/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const UserVerifyRoute = UserVerifyRouteImport.update({
  id: '/user/verify',
  path: '/user/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UserVerifyEmailRoute = UserVerifyEmailRouteImport.update({
  id: '/user/verify-email',
  path: '/user/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOrgSlugIndexRoute = AuthOrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProjectIdRouteRoute =
  AuthOrgSlugProjectIdRouteRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminActivityRoute = AuthAdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthOrgSlugProjectIdIndexRoute =
  AuthOrgSlugProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdDocumentAgentRouteRoute =
  AuthOrgSlugProjectIdDocumentAgentRouteRouteImport.update({
    id: '/document-agent',
    path: '/document-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentRouteRoute =
  AuthOrgSlugProjectIdMarketingAgentRouteRouteImport.update({
    id: '/marketing-agent',
    path: '/marketing-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdPresentationAgentRouteRoute =
  AuthOrgSlugProjectIdPresentationAgentRouteRouteImport.update({
    id: '/presentation-agent',
    path: '/presentation-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdProposalAgentRouteRoute =
  AuthOrgSlugProjectIdProposalAgentRouteRouteImport.update({
    id: '/proposal-agent',
    path: '/proposal-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentRouteRoute =
  AuthOrgSlugProjectIdSearchAgentRouteRouteImport.update({
    id: '/search-agent',
    path: '/search-agent',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugAccountIndexRoute = AuthOrgSlugAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProfileIndexRoute = AuthOrgSlugProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugUsersIndexRoute = AuthOrgSlugUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthOrgSlugRouteRoute,
} as any)
const AuthOrgSlugProjectIdChatIndexRoute =
  AuthOrgSlugProjectIdChatIndexRouteImport.update({
    id: '/chat/',
    path: '/chat/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentIndexRoute =
  AuthOrgSlugProjectIdContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdDocumentAgentIndexRoute =
  AuthOrgSlugProjectIdDocumentAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdDocumentAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentIndexRoute =
  AuthOrgSlugProjectIdMarketingAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdMarketingAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdPresentationAgentIndexRoute =
  AuthOrgSlugProjectIdPresentationAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdPresentationAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdProposalAgentIndexRoute =
  AuthOrgSlugProjectIdProposalAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdProposalAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentIndexRoute =
  AuthOrgSlugProjectIdSearchAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgSlugProjectIdSearchAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdWorkspaceIndexRoute =
  AuthOrgSlugProjectIdWorkspaceIndexRouteImport.update({
    id: '/workspace/',
    path: '/workspace/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugContentConnectorIndexRoute =
  AuthOrgSlugContentConnectorIndexRouteImport.update({
    id: '/content/connector/',
    path: '/content/connector/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugContentFileIndexRoute =
  AuthOrgSlugContentFileIndexRouteImport.update({
    id: '/content/file/',
    path: '/content/file/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugContentTextIndexRoute =
  AuthOrgSlugContentTextIndexRouteImport.update({
    id: '/content/text/',
    path: '/content/text/',
    getParentRoute: () => AuthOrgSlugRouteRoute,
  } as any)
const AuthOrgSlugProjectIdChatConversationIdIndexRoute =
  AuthOrgSlugProjectIdChatConversationIdIndexRouteImport.update({
    id: '/chat/$conversationId/',
    path: '/chat/$conversationId/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentConnectorIndexRoute =
  AuthOrgSlugProjectIdContentConnectorIndexRouteImport.update({
    id: '/content/connector/',
    path: '/content/connector/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentFileIndexRoute =
  AuthOrgSlugProjectIdContentFileIndexRouteImport.update({
    id: '/content/file/',
    path: '/content/file/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdContentTextIndexRoute =
  AuthOrgSlugProjectIdContentTextIndexRouteImport.update({
    id: '/content/text/',
    path: '/content/text/',
    getParentRoute: () => AuthOrgSlugProjectIdRouteRoute,
  } as any)
const AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute =
  AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport.update({
    id: '/$threadId/',
    path: '/$threadId/',
    getParentRoute: () => AuthOrgSlugProjectIdMarketingAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute =
  AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRouteImport.update({
    id: '/$presentationId/',
    path: '/$presentationId/',
    getParentRoute: () => AuthOrgSlugProjectIdPresentationAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute =
  AuthOrgSlugProjectIdProposalAgentProposalIdIndexRouteImport.update({
    id: '/$proposalId/',
    path: '/$proposalId/',
    getParentRoute: () => AuthOrgSlugProjectIdProposalAgentRouteRoute,
  } as any)
const AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute =
  AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport.update({
    id: '/$threadId/',
    path: '/$threadId/',
    getParentRoute: () => AuthOrgSlugProjectIdSearchAgentRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/$orgSlug': typeof AuthOrgSlugRouteRouteWithChildren
  '/admin': typeof AuthAdminRouteRouteWithChildren
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  '/admin/activity': typeof AuthAdminActivityRoute
  '/$orgSlug/': typeof AuthOrgSlugIndexRoute
  '/admin/': typeof AuthAdminIndexRoute
  '/$orgSlug/$projectId/document-agent': typeof AuthOrgSlugProjectIdDocumentAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/presentation-agent': typeof AuthOrgSlugProjectIdPresentationAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/proposal-agent': typeof AuthOrgSlugProjectIdProposalAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  '/$orgSlug/$projectId/': typeof AuthOrgSlugProjectIdIndexRoute
  '/$orgSlug/account/': typeof AuthOrgSlugAccountIndexRoute
  '/$orgSlug/profile/': typeof AuthOrgSlugProfileIndexRoute
  '/$orgSlug/users/': typeof AuthOrgSlugUsersIndexRoute
  '/$orgSlug/$projectId/chat/': typeof AuthOrgSlugProjectIdChatIndexRoute
  '/$orgSlug/$projectId/content/': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/$orgSlug/$projectId/document-agent/': typeof AuthOrgSlugProjectIdDocumentAgentIndexRoute
  '/$orgSlug/$projectId/marketing-agent/': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/$orgSlug/$projectId/presentation-agent/': typeof AuthOrgSlugProjectIdPresentationAgentIndexRoute
  '/$orgSlug/$projectId/proposal-agent/': typeof AuthOrgSlugProjectIdProposalAgentIndexRoute
  '/$orgSlug/$projectId/search-agent/': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/$orgSlug/$projectId/workspace/': typeof AuthOrgSlugProjectIdWorkspaceIndexRoute
  '/$orgSlug/content/connector/': typeof AuthOrgSlugContentConnectorIndexRoute
  '/$orgSlug/content/file/': typeof AuthOrgSlugContentFileIndexRoute
  '/$orgSlug/content/text/': typeof AuthOrgSlugContentTextIndexRoute
  '/$orgSlug/$projectId/chat/$conversationId/': typeof AuthOrgSlugProjectIdChatConversationIdIndexRoute
  '/$orgSlug/$projectId/content/connector/': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/$orgSlug/$projectId/content/file/': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/$orgSlug/$projectId/content/text/': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/$orgSlug/$projectId/marketing-agent/$threadId/': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/$orgSlug/$projectId/presentation-agent/$presentationId/': typeof AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute
  '/$orgSlug/$projectId/proposal-agent/$proposalId/': typeof AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute
  '/$orgSlug/$projectId/search-agent/$threadId/': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRoutesByTo {
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/': typeof AuthIndexRoute
  '/admin/activity': typeof AuthAdminActivityRoute
  '/$orgSlug': typeof AuthOrgSlugIndexRoute
  '/admin': typeof AuthAdminIndexRoute
  '/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdIndexRoute
  '/$orgSlug/account': typeof AuthOrgSlugAccountIndexRoute
  '/$orgSlug/profile': typeof AuthOrgSlugProfileIndexRoute
  '/$orgSlug/users': typeof AuthOrgSlugUsersIndexRoute
  '/$orgSlug/$projectId/chat': typeof AuthOrgSlugProjectIdChatIndexRoute
  '/$orgSlug/$projectId/content': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/$orgSlug/$projectId/document-agent': typeof AuthOrgSlugProjectIdDocumentAgentIndexRoute
  '/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/$orgSlug/$projectId/presentation-agent': typeof AuthOrgSlugProjectIdPresentationAgentIndexRoute
  '/$orgSlug/$projectId/proposal-agent': typeof AuthOrgSlugProjectIdProposalAgentIndexRoute
  '/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/$orgSlug/$projectId/workspace': typeof AuthOrgSlugProjectIdWorkspaceIndexRoute
  '/$orgSlug/content/connector': typeof AuthOrgSlugContentConnectorIndexRoute
  '/$orgSlug/content/file': typeof AuthOrgSlugContentFileIndexRoute
  '/$orgSlug/content/text': typeof AuthOrgSlugContentTextIndexRoute
  '/$orgSlug/$projectId/chat/$conversationId': typeof AuthOrgSlugProjectIdChatConversationIdIndexRoute
  '/$orgSlug/$projectId/content/connector': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/$orgSlug/$projectId/content/file': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/$orgSlug/$projectId/content/text': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/$orgSlug/$projectId/marketing-agent/$threadId': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/$orgSlug/$projectId/presentation-agent/$presentationId': typeof AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute
  '/$orgSlug/$projectId/proposal-agent/$proposalId': typeof AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute
  '/$orgSlug/$projectId/search-agent/$threadId': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/connector-error': typeof ConnectorErrorRoute
  '/login': typeof LoginRoute
  '/org-mismatch': typeof OrgMismatchRoute
  '/payment-inactive': typeof PaymentInactiveRoute
  '/_auth/$orgSlug': typeof AuthOrgSlugRouteRouteWithChildren
  '/_auth/admin': typeof AuthAdminRouteRouteWithChildren
  '/user/password-reset': typeof UserPasswordResetRoute
  '/user/resend-verification': typeof UserResendVerificationRoute
  '/user/set-password': typeof UserSetPasswordRoute
  '/user/verify': typeof UserVerifyRoute
  '/user/verify-email': typeof UserVerifyEmailRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/$orgSlug/$projectId': typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  '/_auth/admin/activity': typeof AuthAdminActivityRoute
  '/_auth/$orgSlug/': typeof AuthOrgSlugIndexRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
  '/_auth/$orgSlug/$projectId/document-agent': typeof AuthOrgSlugProjectIdDocumentAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/marketing-agent': typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/presentation-agent': typeof AuthOrgSlugProjectIdPresentationAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/proposal-agent': typeof AuthOrgSlugProjectIdProposalAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/search-agent': typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  '/_auth/$orgSlug/$projectId/': typeof AuthOrgSlugProjectIdIndexRoute
  '/_auth/$orgSlug/account/': typeof AuthOrgSlugAccountIndexRoute
  '/_auth/$orgSlug/profile/': typeof AuthOrgSlugProfileIndexRoute
  '/_auth/$orgSlug/users/': typeof AuthOrgSlugUsersIndexRoute
  '/_auth/$orgSlug/$projectId/chat/': typeof AuthOrgSlugProjectIdChatIndexRoute
  '/_auth/$orgSlug/$projectId/content/': typeof AuthOrgSlugProjectIdContentIndexRoute
  '/_auth/$orgSlug/$projectId/document-agent/': typeof AuthOrgSlugProjectIdDocumentAgentIndexRoute
  '/_auth/$orgSlug/$projectId/marketing-agent/': typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  '/_auth/$orgSlug/$projectId/presentation-agent/': typeof AuthOrgSlugProjectIdPresentationAgentIndexRoute
  '/_auth/$orgSlug/$projectId/proposal-agent/': typeof AuthOrgSlugProjectIdProposalAgentIndexRoute
  '/_auth/$orgSlug/$projectId/search-agent/': typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  '/_auth/$orgSlug/$projectId/workspace/': typeof AuthOrgSlugProjectIdWorkspaceIndexRoute
  '/_auth/$orgSlug/content/connector/': typeof AuthOrgSlugContentConnectorIndexRoute
  '/_auth/$orgSlug/content/file/': typeof AuthOrgSlugContentFileIndexRoute
  '/_auth/$orgSlug/content/text/': typeof AuthOrgSlugContentTextIndexRoute
  '/_auth/$orgSlug/$projectId/chat/$conversationId/': typeof AuthOrgSlugProjectIdChatConversationIdIndexRoute
  '/_auth/$orgSlug/$projectId/content/connector/': typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  '/_auth/$orgSlug/$projectId/content/file/': typeof AuthOrgSlugProjectIdContentFileIndexRoute
  '/_auth/$orgSlug/$projectId/content/text/': typeof AuthOrgSlugProjectIdContentTextIndexRoute
  '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/': typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
  '/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/': typeof AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute
  '/_auth/$orgSlug/$projectId/proposal-agent/$proposalId/': typeof AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute
  '/_auth/$orgSlug/$projectId/search-agent/$threadId/': typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/$orgSlug'
    | '/admin'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/$orgSlug/$projectId'
    | '/admin/activity'
    | '/$orgSlug/'
    | '/admin/'
    | '/$orgSlug/$projectId/document-agent'
    | '/$orgSlug/$projectId/marketing-agent'
    | '/$orgSlug/$projectId/presentation-agent'
    | '/$orgSlug/$projectId/proposal-agent'
    | '/$orgSlug/$projectId/search-agent'
    | '/$orgSlug/$projectId/'
    | '/$orgSlug/account/'
    | '/$orgSlug/profile/'
    | '/$orgSlug/users/'
    | '/$orgSlug/$projectId/chat/'
    | '/$orgSlug/$projectId/content/'
    | '/$orgSlug/$projectId/document-agent/'
    | '/$orgSlug/$projectId/marketing-agent/'
    | '/$orgSlug/$projectId/presentation-agent/'
    | '/$orgSlug/$projectId/proposal-agent/'
    | '/$orgSlug/$projectId/search-agent/'
    | '/$orgSlug/$projectId/workspace/'
    | '/$orgSlug/content/connector/'
    | '/$orgSlug/content/file/'
    | '/$orgSlug/content/text/'
    | '/$orgSlug/$projectId/chat/$conversationId/'
    | '/$orgSlug/$projectId/content/connector/'
    | '/$orgSlug/$projectId/content/file/'
    | '/$orgSlug/$projectId/content/text/'
    | '/$orgSlug/$projectId/marketing-agent/$threadId/'
    | '/$orgSlug/$projectId/presentation-agent/$presentationId/'
    | '/$orgSlug/$projectId/proposal-agent/$proposalId/'
    | '/$orgSlug/$projectId/search-agent/$threadId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/'
    | '/admin/activity'
    | '/$orgSlug'
    | '/admin'
    | '/$orgSlug/$projectId'
    | '/$orgSlug/account'
    | '/$orgSlug/profile'
    | '/$orgSlug/users'
    | '/$orgSlug/$projectId/chat'
    | '/$orgSlug/$projectId/content'
    | '/$orgSlug/$projectId/document-agent'
    | '/$orgSlug/$projectId/marketing-agent'
    | '/$orgSlug/$projectId/presentation-agent'
    | '/$orgSlug/$projectId/proposal-agent'
    | '/$orgSlug/$projectId/search-agent'
    | '/$orgSlug/$projectId/workspace'
    | '/$orgSlug/content/connector'
    | '/$orgSlug/content/file'
    | '/$orgSlug/content/text'
    | '/$orgSlug/$projectId/chat/$conversationId'
    | '/$orgSlug/$projectId/content/connector'
    | '/$orgSlug/$projectId/content/file'
    | '/$orgSlug/$projectId/content/text'
    | '/$orgSlug/$projectId/marketing-agent/$threadId'
    | '/$orgSlug/$projectId/presentation-agent/$presentationId'
    | '/$orgSlug/$projectId/proposal-agent/$proposalId'
    | '/$orgSlug/$projectId/search-agent/$threadId'
  id:
    | '__root__'
    | '/_auth'
    | '/connector-error'
    | '/login'
    | '/org-mismatch'
    | '/payment-inactive'
    | '/_auth/$orgSlug'
    | '/_auth/admin'
    | '/user/password-reset'
    | '/user/resend-verification'
    | '/user/set-password'
    | '/user/verify'
    | '/user/verify-email'
    | '/_auth/'
    | '/_auth/$orgSlug/$projectId'
    | '/_auth/admin/activity'
    | '/_auth/$orgSlug/'
    | '/_auth/admin/'
    | '/_auth/$orgSlug/$projectId/document-agent'
    | '/_auth/$orgSlug/$projectId/marketing-agent'
    | '/_auth/$orgSlug/$projectId/presentation-agent'
    | '/_auth/$orgSlug/$projectId/proposal-agent'
    | '/_auth/$orgSlug/$projectId/search-agent'
    | '/_auth/$orgSlug/$projectId/'
    | '/_auth/$orgSlug/account/'
    | '/_auth/$orgSlug/profile/'
    | '/_auth/$orgSlug/users/'
    | '/_auth/$orgSlug/$projectId/chat/'
    | '/_auth/$orgSlug/$projectId/content/'
    | '/_auth/$orgSlug/$projectId/document-agent/'
    | '/_auth/$orgSlug/$projectId/marketing-agent/'
    | '/_auth/$orgSlug/$projectId/presentation-agent/'
    | '/_auth/$orgSlug/$projectId/proposal-agent/'
    | '/_auth/$orgSlug/$projectId/search-agent/'
    | '/_auth/$orgSlug/$projectId/workspace/'
    | '/_auth/$orgSlug/content/connector/'
    | '/_auth/$orgSlug/content/file/'
    | '/_auth/$orgSlug/content/text/'
    | '/_auth/$orgSlug/$projectId/chat/$conversationId/'
    | '/_auth/$orgSlug/$projectId/content/connector/'
    | '/_auth/$orgSlug/$projectId/content/file/'
    | '/_auth/$orgSlug/$projectId/content/text/'
    | '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/'
    | '/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/'
    | '/_auth/$orgSlug/$projectId/proposal-agent/$proposalId/'
    | '/_auth/$orgSlug/$projectId/search-agent/$threadId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConnectorErrorRoute: typeof ConnectorErrorRoute
  LoginRoute: typeof LoginRoute
  OrgMismatchRoute: typeof OrgMismatchRoute
  PaymentInactiveRoute: typeof PaymentInactiveRoute
  UserPasswordResetRoute: typeof UserPasswordResetRoute
  UserResendVerificationRoute: typeof UserResendVerificationRoute
  UserSetPasswordRoute: typeof UserSetPasswordRoute
  UserVerifyRoute: typeof UserVerifyRoute
  UserVerifyEmailRoute: typeof UserVerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connector-error': {
      id: '/connector-error'
      path: '/connector-error'
      fullPath: '/connector-error'
      preLoaderRoute: typeof ConnectorErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-mismatch': {
      id: '/org-mismatch'
      path: '/org-mismatch'
      fullPath: '/org-mismatch'
      preLoaderRoute: typeof OrgMismatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-inactive': {
      id: '/payment-inactive'
      path: '/payment-inactive'
      fullPath: '/payment-inactive'
      preLoaderRoute: typeof PaymentInactiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/$orgSlug': {
      id: '/_auth/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/$orgSlug'
      preLoaderRoute: typeof AuthOrgSlugRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/user/password-reset': {
      id: '/user/password-reset'
      path: '/user/password-reset'
      fullPath: '/user/password-reset'
      preLoaderRoute: typeof UserPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/resend-verification': {
      id: '/user/resend-verification'
      path: '/user/resend-verification'
      fullPath: '/user/resend-verification'
      preLoaderRoute: typeof UserResendVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/set-password': {
      id: '/user/set-password'
      path: '/user/set-password'
      fullPath: '/user/set-password'
      preLoaderRoute: typeof UserSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/verify': {
      id: '/user/verify'
      path: '/user/verify'
      fullPath: '/user/verify'
      preLoaderRoute: typeof UserVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/verify-email': {
      id: '/user/verify-email'
      path: '/user/verify-email'
      fullPath: '/user/verify-email'
      preLoaderRoute: typeof UserVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/$orgSlug/': {
      id: '/_auth/$orgSlug/'
      path: '/'
      fullPath: '/$orgSlug/'
      preLoaderRoute: typeof AuthOrgSlugIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId': {
      id: '/_auth/$orgSlug/$projectId'
      path: '/$projectId'
      fullPath: '/$orgSlug/$projectId'
      preLoaderRoute: typeof AuthOrgSlugProjectIdRouteRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/activity': {
      id: '/_auth/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AuthAdminActivityRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/$orgSlug/$projectId/': {
      id: '/_auth/$orgSlug/$projectId/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/document-agent': {
      id: '/_auth/$orgSlug/$projectId/document-agent'
      path: '/document-agent'
      fullPath: '/$orgSlug/$projectId/document-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdDocumentAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent'
      path: '/marketing-agent'
      fullPath: '/$orgSlug/$projectId/marketing-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/presentation-agent': {
      id: '/_auth/$orgSlug/$projectId/presentation-agent'
      path: '/presentation-agent'
      fullPath: '/$orgSlug/$projectId/presentation-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdPresentationAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/proposal-agent': {
      id: '/_auth/$orgSlug/$projectId/proposal-agent'
      path: '/proposal-agent'
      fullPath: '/$orgSlug/$projectId/proposal-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdProposalAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent': {
      id: '/_auth/$orgSlug/$projectId/search-agent'
      path: '/search-agent'
      fullPath: '/$orgSlug/$projectId/search-agent'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/account/': {
      id: '/_auth/$orgSlug/account/'
      path: '/account'
      fullPath: '/$orgSlug/account/'
      preLoaderRoute: typeof AuthOrgSlugAccountIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/profile/': {
      id: '/_auth/$orgSlug/profile/'
      path: '/profile'
      fullPath: '/$orgSlug/profile/'
      preLoaderRoute: typeof AuthOrgSlugProfileIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/users/': {
      id: '/_auth/$orgSlug/users/'
      path: '/users'
      fullPath: '/$orgSlug/users/'
      preLoaderRoute: typeof AuthOrgSlugUsersIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId/chat/': {
      id: '/_auth/$orgSlug/$projectId/chat/'
      path: '/chat'
      fullPath: '/$orgSlug/$projectId/chat/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdChatIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/': {
      id: '/_auth/$orgSlug/$projectId/content/'
      path: '/content'
      fullPath: '/$orgSlug/$projectId/content/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/document-agent/': {
      id: '/_auth/$orgSlug/$projectId/document-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/document-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdDocumentAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdDocumentAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent/': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/marketing-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/presentation-agent/': {
      id: '/_auth/$orgSlug/$projectId/presentation-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/presentation-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdPresentationAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdPresentationAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/proposal-agent/': {
      id: '/_auth/$orgSlug/$projectId/proposal-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/proposal-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdProposalAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdProposalAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent/': {
      id: '/_auth/$orgSlug/$projectId/search-agent/'
      path: '/'
      fullPath: '/$orgSlug/$projectId/search-agent/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/workspace/': {
      id: '/_auth/$orgSlug/$projectId/workspace/'
      path: '/workspace'
      fullPath: '/$orgSlug/$projectId/workspace/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdWorkspaceIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/content/connector/': {
      id: '/_auth/$orgSlug/content/connector/'
      path: '/content/connector'
      fullPath: '/$orgSlug/content/connector/'
      preLoaderRoute: typeof AuthOrgSlugContentConnectorIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/content/file/': {
      id: '/_auth/$orgSlug/content/file/'
      path: '/content/file'
      fullPath: '/$orgSlug/content/file/'
      preLoaderRoute: typeof AuthOrgSlugContentFileIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/content/text/': {
      id: '/_auth/$orgSlug/content/text/'
      path: '/content/text'
      fullPath: '/$orgSlug/content/text/'
      preLoaderRoute: typeof AuthOrgSlugContentTextIndexRouteImport
      parentRoute: typeof AuthOrgSlugRouteRoute
    }
    '/_auth/$orgSlug/$projectId/chat/$conversationId/': {
      id: '/_auth/$orgSlug/$projectId/chat/$conversationId/'
      path: '/chat/$conversationId'
      fullPath: '/$orgSlug/$projectId/chat/$conversationId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdChatConversationIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/connector/': {
      id: '/_auth/$orgSlug/$projectId/content/connector/'
      path: '/content/connector'
      fullPath: '/$orgSlug/$projectId/content/connector/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentConnectorIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/file/': {
      id: '/_auth/$orgSlug/$projectId/content/file/'
      path: '/content/file'
      fullPath: '/$orgSlug/$projectId/content/file/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentFileIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/content/text/': {
      id: '/_auth/$orgSlug/$projectId/content/text/'
      path: '/content/text'
      fullPath: '/$orgSlug/$projectId/content/text/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdContentTextIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdRouteRoute
    }
    '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/': {
      id: '/_auth/$orgSlug/$projectId/marketing-agent/$threadId/'
      path: '/$threadId'
      fullPath: '/$orgSlug/$projectId/marketing-agent/$threadId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/': {
      id: '/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/'
      path: '/$presentationId'
      fullPath: '/$orgSlug/$projectId/presentation-agent/$presentationId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdPresentationAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/proposal-agent/$proposalId/': {
      id: '/_auth/$orgSlug/$projectId/proposal-agent/$proposalId/'
      path: '/$proposalId'
      fullPath: '/$orgSlug/$projectId/proposal-agent/$proposalId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdProposalAgentProposalIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdProposalAgentRouteRoute
    }
    '/_auth/$orgSlug/$projectId/search-agent/$threadId/': {
      id: '/_auth/$orgSlug/$projectId/search-agent/$threadId/'
      path: '/$threadId'
      fullPath: '/$orgSlug/$projectId/search-agent/$threadId/'
      preLoaderRoute: typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRouteImport
      parentRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRoute
    }
  }
}

interface AuthOrgSlugProjectIdDocumentAgentRouteRouteChildren {
  AuthOrgSlugProjectIdDocumentAgentIndexRoute: typeof AuthOrgSlugProjectIdDocumentAgentIndexRoute
}

const AuthOrgSlugProjectIdDocumentAgentRouteRouteChildren: AuthOrgSlugProjectIdDocumentAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdDocumentAgentIndexRoute:
      AuthOrgSlugProjectIdDocumentAgentIndexRoute,
  }

const AuthOrgSlugProjectIdDocumentAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdDocumentAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdDocumentAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren {
  AuthOrgSlugProjectIdMarketingAgentIndexRoute: typeof AuthOrgSlugProjectIdMarketingAgentIndexRoute
  AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute: typeof AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute
}

const AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren: AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdMarketingAgentIndexRoute:
      AuthOrgSlugProjectIdMarketingAgentIndexRoute,
    AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute:
      AuthOrgSlugProjectIdMarketingAgentThreadIdIndexRoute,
  }

const AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdMarketingAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdMarketingAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdPresentationAgentRouteRouteChildren {
  AuthOrgSlugProjectIdPresentationAgentIndexRoute: typeof AuthOrgSlugProjectIdPresentationAgentIndexRoute
  AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute: typeof AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute
}

const AuthOrgSlugProjectIdPresentationAgentRouteRouteChildren: AuthOrgSlugProjectIdPresentationAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdPresentationAgentIndexRoute:
      AuthOrgSlugProjectIdPresentationAgentIndexRoute,
    AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute:
      AuthOrgSlugProjectIdPresentationAgentPresentationIdIndexRoute,
  }

const AuthOrgSlugProjectIdPresentationAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdPresentationAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdPresentationAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdProposalAgentRouteRouteChildren {
  AuthOrgSlugProjectIdProposalAgentIndexRoute: typeof AuthOrgSlugProjectIdProposalAgentIndexRoute
  AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute: typeof AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute
}

const AuthOrgSlugProjectIdProposalAgentRouteRouteChildren: AuthOrgSlugProjectIdProposalAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdProposalAgentIndexRoute:
      AuthOrgSlugProjectIdProposalAgentIndexRoute,
    AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute:
      AuthOrgSlugProjectIdProposalAgentProposalIdIndexRoute,
  }

const AuthOrgSlugProjectIdProposalAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdProposalAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdProposalAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdSearchAgentRouteRouteChildren {
  AuthOrgSlugProjectIdSearchAgentIndexRoute: typeof AuthOrgSlugProjectIdSearchAgentIndexRoute
  AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute: typeof AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute
}

const AuthOrgSlugProjectIdSearchAgentRouteRouteChildren: AuthOrgSlugProjectIdSearchAgentRouteRouteChildren =
  {
    AuthOrgSlugProjectIdSearchAgentIndexRoute:
      AuthOrgSlugProjectIdSearchAgentIndexRoute,
    AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute:
      AuthOrgSlugProjectIdSearchAgentThreadIdIndexRoute,
  }

const AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren =
  AuthOrgSlugProjectIdSearchAgentRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdSearchAgentRouteRouteChildren,
  )

interface AuthOrgSlugProjectIdRouteRouteChildren {
  AuthOrgSlugProjectIdDocumentAgentRouteRoute: typeof AuthOrgSlugProjectIdDocumentAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdMarketingAgentRouteRoute: typeof AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdPresentationAgentRouteRoute: typeof AuthOrgSlugProjectIdPresentationAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdProposalAgentRouteRoute: typeof AuthOrgSlugProjectIdProposalAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdSearchAgentRouteRoute: typeof AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren
  AuthOrgSlugProjectIdIndexRoute: typeof AuthOrgSlugProjectIdIndexRoute
  AuthOrgSlugProjectIdChatIndexRoute: typeof AuthOrgSlugProjectIdChatIndexRoute
  AuthOrgSlugProjectIdContentIndexRoute: typeof AuthOrgSlugProjectIdContentIndexRoute
  AuthOrgSlugProjectIdWorkspaceIndexRoute: typeof AuthOrgSlugProjectIdWorkspaceIndexRoute
  AuthOrgSlugProjectIdChatConversationIdIndexRoute: typeof AuthOrgSlugProjectIdChatConversationIdIndexRoute
  AuthOrgSlugProjectIdContentConnectorIndexRoute: typeof AuthOrgSlugProjectIdContentConnectorIndexRoute
  AuthOrgSlugProjectIdContentFileIndexRoute: typeof AuthOrgSlugProjectIdContentFileIndexRoute
  AuthOrgSlugProjectIdContentTextIndexRoute: typeof AuthOrgSlugProjectIdContentTextIndexRoute
}

const AuthOrgSlugProjectIdRouteRouteChildren: AuthOrgSlugProjectIdRouteRouteChildren =
  {
    AuthOrgSlugProjectIdDocumentAgentRouteRoute:
      AuthOrgSlugProjectIdDocumentAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdMarketingAgentRouteRoute:
      AuthOrgSlugProjectIdMarketingAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdPresentationAgentRouteRoute:
      AuthOrgSlugProjectIdPresentationAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdProposalAgentRouteRoute:
      AuthOrgSlugProjectIdProposalAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdSearchAgentRouteRoute:
      AuthOrgSlugProjectIdSearchAgentRouteRouteWithChildren,
    AuthOrgSlugProjectIdIndexRoute: AuthOrgSlugProjectIdIndexRoute,
    AuthOrgSlugProjectIdChatIndexRoute: AuthOrgSlugProjectIdChatIndexRoute,
    AuthOrgSlugProjectIdContentIndexRoute:
      AuthOrgSlugProjectIdContentIndexRoute,
    AuthOrgSlugProjectIdWorkspaceIndexRoute:
      AuthOrgSlugProjectIdWorkspaceIndexRoute,
    AuthOrgSlugProjectIdChatConversationIdIndexRoute:
      AuthOrgSlugProjectIdChatConversationIdIndexRoute,
    AuthOrgSlugProjectIdContentConnectorIndexRoute:
      AuthOrgSlugProjectIdContentConnectorIndexRoute,
    AuthOrgSlugProjectIdContentFileIndexRoute:
      AuthOrgSlugProjectIdContentFileIndexRoute,
    AuthOrgSlugProjectIdContentTextIndexRoute:
      AuthOrgSlugProjectIdContentTextIndexRoute,
  }

const AuthOrgSlugProjectIdRouteRouteWithChildren =
  AuthOrgSlugProjectIdRouteRoute._addFileChildren(
    AuthOrgSlugProjectIdRouteRouteChildren,
  )

interface AuthOrgSlugRouteRouteChildren {
  AuthOrgSlugProjectIdRouteRoute: typeof AuthOrgSlugProjectIdRouteRouteWithChildren
  AuthOrgSlugIndexRoute: typeof AuthOrgSlugIndexRoute
  AuthOrgSlugAccountIndexRoute: typeof AuthOrgSlugAccountIndexRoute
  AuthOrgSlugProfileIndexRoute: typeof AuthOrgSlugProfileIndexRoute
  AuthOrgSlugUsersIndexRoute: typeof AuthOrgSlugUsersIndexRoute
  AuthOrgSlugContentConnectorIndexRoute: typeof AuthOrgSlugContentConnectorIndexRoute
  AuthOrgSlugContentFileIndexRoute: typeof AuthOrgSlugContentFileIndexRoute
  AuthOrgSlugContentTextIndexRoute: typeof AuthOrgSlugContentTextIndexRoute
}

const AuthOrgSlugRouteRouteChildren: AuthOrgSlugRouteRouteChildren = {
  AuthOrgSlugProjectIdRouteRoute: AuthOrgSlugProjectIdRouteRouteWithChildren,
  AuthOrgSlugIndexRoute: AuthOrgSlugIndexRoute,
  AuthOrgSlugAccountIndexRoute: AuthOrgSlugAccountIndexRoute,
  AuthOrgSlugProfileIndexRoute: AuthOrgSlugProfileIndexRoute,
  AuthOrgSlugUsersIndexRoute: AuthOrgSlugUsersIndexRoute,
  AuthOrgSlugContentConnectorIndexRoute: AuthOrgSlugContentConnectorIndexRoute,
  AuthOrgSlugContentFileIndexRoute: AuthOrgSlugContentFileIndexRoute,
  AuthOrgSlugContentTextIndexRoute: AuthOrgSlugContentTextIndexRoute,
}

const AuthOrgSlugRouteRouteWithChildren =
  AuthOrgSlugRouteRoute._addFileChildren(AuthOrgSlugRouteRouteChildren)

interface AuthAdminRouteRouteChildren {
  AuthAdminActivityRoute: typeof AuthAdminActivityRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminActivityRoute: AuthAdminActivityRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthOrgSlugRouteRoute: typeof AuthOrgSlugRouteRouteWithChildren
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthOrgSlugRouteRoute: AuthOrgSlugRouteRouteWithChildren,
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConnectorErrorRoute: ConnectorErrorRoute,
  LoginRoute: LoginRoute,
  OrgMismatchRoute: OrgMismatchRoute,
  PaymentInactiveRoute: PaymentInactiveRoute,
  UserPasswordResetRoute: UserPasswordResetRoute,
  UserResendVerificationRoute: UserResendVerificationRoute,
  UserSetPasswordRoute: UserSetPasswordRoute,
  UserVerifyRoute: UserVerifyRoute,
  UserVerifyEmailRoute: UserVerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
